<template>
  <li
    v-if="name"
    class="activity-list-item grid-x grid-padding-x">
    <div class="cell small-14">
      <h3 class="overflow-wrap">
        <router-link :to="url">
          {{ name }}
        </router-link>
      </h3>
      <div class="grid-x">
        <div
          v-if="ageRange"
          class="cell auto">Ages:<br> {{ ageRange }}</div>
        <div
          v-if="gender"
          class="cell auto">Gender:<br> {{ gender }}</div>
        <div
          v-if="feeDescription"
          class="cell auto">Cost:<br> {{ feeDescription }}</div>
      </div>
    </div>
    <div class="cell auto">
      <p>{{ locationName }}</p>
      <address>{{ fullAddress }}</address>
    </div>
  </li>
</template>

<script>
import {
  concatAddress,
  getAgeRange,
  getFeeDescription
} from '~/util'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    slug: {
      type: String,
      required: false,
      default: ''
    },
    fee: {
      type: String,
      default: ''
    },
    feeFrequency: {
      type: String,
      default: ''
    },
    gender: {
      type: String,
      default: ''
    },
    ageLow: {
      type: Number,
      required: true
    },
    ageHigh: {
      type: Number,
      required: true
    },
    locationName: {
      type: String,
      required: true
    },
    locationAddress: {
      type: Object,
      required: true
    }
  },
  computed: {
    url () {
      return `/activity/${this.slug}/${this.id}`
    },
    fullAddress () {
      return concatAddress(this.locationAddress)
    },
    ageRange () {
      return getAgeRange(this.ageLow, this.ageHigh)
    },
    feeDescription () {
      if (this.fee) {
        return getFeeDescription(this.fee, this.feeFrequency)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.activity-list-item
  font-size: .9rem

li
  border-bottom: 1px solid black
  margin-bottom: 1rem
  padding-bottom: 1rem

  &:last-child
    border-bottom: none
</style>



// WEBPACK FOOTER //
// src/components/ActivityListItem.vue